/**
 * MOCK DATA — All cases and persons are entirely fictional.
 * No real missing children data is used anywhere in this application.
 * For production, replace with live DynamoDB queries via AWS AppSync/API Gateway.
 */

export const MOCK_CASES = [
  {
    id: 'CGS-001',
    caseNumber: 'Case #001',
    name: 'Alex Morgan',
    age: 9,
    gender: 'Male',
    race: 'Caucasian',
    hairColor: 'Brown',
    eyeColor: 'Green',
    height: "4'2\"",
    weight: '65 lbs',
    lastSeenDate: '2024-11-14',
    lastSeenLocation: 'Riverside Park, Springfield, IL',
    circumstance: 'Alex was last seen leaving Riverside Elementary School after afternoon recess. He was wearing a red hoodie and blue jeans.',
    missingFrom: 'Springfield, IL',
    status: 'active',
    caseAgency: 'Springfield Police Department',
    ncmecNumber: 'NCMEC-DEMO-001',
    // In production: S3 pre-signed URL fetched server-side
    // TODO: AWS Rekognition integration — face indexed on upload for cross-case matching
    photo: null,
    photoPlaceholderColor: '#1A3A5C',
    photoInitials: 'AM',
  },
  {
    id: 'CGS-002',
    caseNumber: 'Case #002',
    name: 'Sophia Chen',
    age: 12,
    gender: 'Female',
    race: 'Asian',
    hairColor: 'Black',
    eyeColor: 'Brown',
    height: "4'9\"",
    weight: '85 lbs',
    lastSeenDate: '2024-11-20',
    lastSeenLocation: 'Oakwood Mall, Denver, CO',
    circumstance: 'Sophia was last seen at Oakwood Mall with friends. She separated from the group near the food court and did not return home.',
    missingFrom: 'Denver, CO',
    status: 'active',
    caseAgency: 'Denver Police Department',
    ncmecNumber: 'NCMEC-DEMO-002',
    photo: null,
    photoPlaceholderColor: '#1C3D5A',
    photoInitials: 'SC',
  },
  {
    id: 'CGS-003',
    caseNumber: 'Case #003',
    name: 'Marcus Williams',
    age: 7,
    gender: 'Male',
    race: 'African American',
    hairColor: 'Black',
    eyeColor: 'Brown',
    height: "3'11\"",
    weight: '55 lbs',
    lastSeenDate: '2024-10-30',
    lastSeenLocation: 'Cedar Creek Neighborhood, Atlanta, GA',
    circumstance: 'Marcus was playing in the front yard of his home when neighbors noticed he was no longer present. Family searched the area and contacted police.',
    missingFrom: 'Atlanta, GA',
    status: 'active',
    caseAgency: 'Atlanta Police Department',
    ncmecNumber: 'NCMEC-DEMO-003',
    photo: null,
    photoPlaceholderColor: '#14304A',
    photoInitials: 'MW',
  },
  {
    id: 'CGS-004',
    caseNumber: 'Case #004',
    name: 'Isabella Torres',
    age: 14,
    gender: 'Female',
    race: 'Hispanic',
    hairColor: 'Dark Brown',
    eyeColor: 'Hazel',
    height: "5'2\"",
    weight: '110 lbs',
    lastSeenDate: '2024-12-01',
    lastSeenLocation: 'Downtown Bus Terminal, Phoenix, AZ',
    circumstance: 'Isabella was seen at the central bus terminal by a station employee. She appeared to be alone and was carrying a large backpack. Last seen boarding Bus Route 47.',
    missingFrom: 'Phoenix, AZ',
    status: 'active',
    caseAgency: 'Phoenix Police Department',
    ncmecNumber: 'NCMEC-DEMO-004',
    photo: null,
    photoPlaceholderColor: '#1E3D60',
    photoInitials: 'IT',
  },
  {
    id: 'CGS-005',
    caseNumber: 'Case #005',
    name: 'Ethan Park',
    age: 10,
    gender: 'Male',
    race: 'Asian',
    hairColor: 'Black',
    eyeColor: 'Brown',
    height: "4'5\"",
    weight: '72 lbs',
    lastSeenDate: '2024-09-15',
    lastSeenLocation: 'Lakeshore Trail, Chicago, IL',
    circumstance: 'Ethan was on a weekend bike ride along Lakeshore Trail with his older brother. The two separated near mile marker 8. Ethan\'s bike was recovered abandoned at mile marker 9.',
    missingFrom: 'Chicago, IL',
    status: 'active',
    caseAgency: 'Chicago Police Department',
    ncmecNumber: 'NCMEC-DEMO-005',
    photo: null,
    photoPlaceholderColor: '#162B48',
    photoInitials: 'EP',
  },
  {
    id: 'CGS-006',
    caseNumber: 'Case #006',
    name: 'Amara Johnson',
    age: 8,
    gender: 'Female',
    race: 'African American',
    hairColor: 'Black',
    eyeColor: 'Brown',
    height: "4'0\"",
    weight: '58 lbs',
    lastSeenDate: '2024-08-22',
    lastSeenLocation: 'Sunset Community Center, Houston, TX',
    circumstance: 'Amara attended an after-school program at Sunset Community Center. She was signed out by an individual whose identity could not be verified. Surveillance footage is under review.',
    missingFrom: 'Houston, TX',
    status: 'active',
    caseAgency: 'Houston Police Department',
    ncmecNumber: 'NCMEC-DEMO-006',
    photo: null,
    photoPlaceholderColor: '#1A3550',
    photoInitials: 'AJ',
  },
  {
    id: 'CGS-007',
    caseNumber: 'Case #007',
    name: 'Noah Rivera',
    age: 13,
    gender: 'Male',
    race: 'Hispanic',
    hairColor: 'Brown',
    eyeColor: 'Brown',
    height: "5'0\"",
    weight: '98 lbs',
    lastSeenDate: '2024-07-10',
    lastSeenLocation: 'Westside Skate Park, Los Angeles, CA',
    circumstance: 'Noah left home on his skateboard to meet friends at Westside Skate Park. He arrived but left alone approximately 45 minutes later according to witnesses. He never returned home.',
    missingFrom: 'Los Angeles, CA',
    status: 'active',
    caseAgency: 'Los Angeles Police Department',
    ncmecNumber: 'NCMEC-DEMO-007',
    photo: null,
    photoPlaceholderColor: '#112640',
    photoInitials: 'NR',
  },
  {
    id: 'CGS-008',
    caseNumber: 'Case #008',
    name: 'Lily Thompson',
    age: 6,
    gender: 'Female',
    race: 'Caucasian',
    hairColor: 'Blonde',
    eyeColor: 'Blue',
    height: "3'8\"",
    weight: '45 lbs',
    lastSeenDate: '2024-06-03',
    lastSeenLocation: 'Greenfield State Fair, Columbus, OH',
    circumstance: 'Lily was reported missing from her family at the Greenfield State Fair. The family was separated near the carousel at approximately 3:00 PM. An amber alert was issued.',
    missingFrom: 'Columbus, OH',
    status: 'active',
    caseAgency: 'Columbus Division of Police',
    ncmecNumber: 'NCMEC-DEMO-008',
    photo: null,
    photoPlaceholderColor: '#1C3E5E',
    photoInitials: 'LT',
  },
  {
    id: 'CGS-009',
    caseNumber: 'Case #009',
    name: 'Jayden Brooks',
    age: 11,
    gender: 'Male',
    race: 'African American',
    hairColor: 'Black',
    eyeColor: 'Brown',
    height: "4'7\"",
    weight: '80 lbs',
    lastSeenDate: '2024-05-18',
    lastSeenLocation: 'Harbor District, Seattle, WA',
    circumstance: 'Jayden was last seen near the Harbor District waterfront. He had told family he was going to visit a friend two blocks away. The friend reported he never arrived.',
    missingFrom: 'Seattle, WA',
    status: 'active',
    caseAgency: 'Seattle Police Department',
    ncmecNumber: 'NCMEC-DEMO-009',
    photo: null,
    photoPlaceholderColor: '#153347',
    photoInitials: 'JB',
  },
  {
    id: 'CGS-010',
    caseNumber: 'Case #010',
    name: 'Emma Patel',
    age: 15,
    gender: 'Female',
    race: 'South Asian',
    hairColor: 'Black',
    eyeColor: 'Brown',
    height: "5'4\"",
    weight: '120 lbs',
    lastSeenDate: '2024-04-07',
    lastSeenLocation: 'Northgate Metro Station, Washington, DC',
    circumstance: 'Emma was last seen exiting Northgate Metro Station after school. Security cameras tracked her to the station exit. She did not board her usual connecting bus home.',
    missingFrom: 'Washington, DC',
    status: 'active',
    caseAgency: 'Metropolitan Police Department',
    ncmecNumber: 'NCMEC-DEMO-010',
    photo: null,
    photoPlaceholderColor: '#183A58',
    photoInitials: 'EP2',
  },
];

/**
 * DEMO TEST ACCOUNTS
 * These credentials are for UI demonstration only.
 * In production, accounts are created in Amazon Cognito User Pools
 * and assigned to groups: public, law_enforcement, admin
 *
 * Role Permissions:
 *   public          — view gallery, submit sightings, view own submissions
 *   law_enforcement — all public + view full case details, contact info, download reports
 *   admin           — all LE + manage cases, manage users, view audit logs
 */
export const DEMO_ACCOUNTS = [
  {
    role: 'public',
    email: 'public.demo@childguard-demo.test',
    password: 'Demo@Public2024',
    displayName: 'Public User',
    description: 'Standard public account — can browse gallery and submit sightings',
  },
  {
    role: 'law_enforcement',
    email: 'officer.demo@childguard-demo.test',
    password: 'Demo@Officer2024',
    displayName: 'Officer Demo',
    badgeNumber: 'DEMO-4721',
    agency: 'Demo County Sheriff\'s Office',
    description: 'Law enforcement account — full case details, contact info, reporting tools',
  },
  {
    role: 'admin',
    email: 'admin.demo@childguard-demo.test',
    password: 'Demo@Admin2024',
    displayName: 'Admin User',
    description: 'Administrator account — full platform access including case management',
  },
];

export const PLATFORM_STATS = {
  casesInDatabase: 2847,
  sightingsSubmitted: 14203,
  casesResolved: 1891,
  statesActive: 50,
  // Last updated timestamp for display
  lastUpdated: 'Demo Data',
};
